import { ProfilePopup } from './profile-popup';

import { showContextMenu } from '@/shared/utils/show-context-menu';

interface ShowProfilePopupOptions {
  position: { x: number; y: number };
  profileImageUrl: string;
  username: string;
  nickname?: string;
  followerCount: number;
  profileUrl: string;
}

export function showProfilePopup({
  position,
  profileImageUrl,
  username,
  nickname,
  followerCount,
  profileUrl,
}: ShowProfilePopupOptions): Promise<void> {
  return new Promise((resolve) => {
    showContextMenu({
      position,
      className: 'w-[344px] p-0',
      children: (
        <ProfilePopup
          profileImageUrl={profileImageUrl}
          username={username}
          nickname={nickname}
          followerCount={followerCount}
          profileUrl={profileUrl}
          onClose={() => resolve()}
        />
      ),
    }).then(() => {
      resolve();
    });
  });
}
